/* eslint-disable react/display-name */
import React, { useState, useEffect, useRef } from 'react'
import { withTranslation } from 'react-i18next'
import { gql, useApolloClient, useMutation, useQuery } from '@apollo/client'
import Header from '../components/Headers/Header'
import CustomLoader from '../components/Loader/CustomLoader'
import { getallcategories, deletecategory, SearchCategories } from '../apollo'
import DataTable from 'react-data-table-component'
import orderBy from 'lodash/orderBy'
import { customStyles } from '../utils/tableforManageCategeory'
import useGlobalStyles from '../utils/globalStyles'
import {
  Container,
  Button,
  Grid,
  Modal,
  MenuItem,
  IconButton,
  Menu,
  ListItemIcon,
  Typography,
  Paper,
  useTheme, Box, Snackbar, Alert
} from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import TableHeader from '../components/TableHeader'
import AddCategory from '../components/AddCategory/AddCategory'
import { Icon } from '@iconify/react';
import AddSubCategory from '../components/AddSubCategory/AddSubCategory'
import SearchBar from '../components/TableHeader/SearchBar'
import { useHistory } from 'react-router-dom'; // Import useHistory

// --- PERSISTENCE CONSTANTS ---
const LAST_CATEGORY_LIST_PAGE = 'lastCategoryListPage';
const LAST_CATEGORY_LIST_SCROLL_POS = 'lastCategoryListScrollPos';
const LAST_CATEGORY_LIST_PER_PAGE = 'lastCategoryListPerPage';
const IS_BACK_FROM_SUB_CATEGORY = 'isBackFromSubCategory';
const LAST_SELECTED_CATEGORY_ID = 'lastSelectedCategoryId';
const LAST_CATEGORY_SEARCH_QUERY = 'lastCategorySearchQuery';
const IS_CATEGORY_SEARCH_ACTIVE = 'isCategorySearchActive';
// --- END PERSISTENCE CONSTANTS ---

const GET_ALL_CATEGORIES = gql`
  ${getallcategories}
`
const DELETE_CATEGORY = gql`
  ${deletecategory}
`
const GET_SEARCH_CATEGORIES = gql`
  ${SearchCategories}
`

const ManageCategory = props => {
  const theme = useTheme();
  const { t } = props;
  const history = useHistory(); // Initialize useHistory
  const client = useApolloClient();
  const golbalClasses = useGlobalStyles()

  const [editModal, setEditModal] = useState(false)
  const [addVendorModal, setAddVendorModal] = useState(false)
  const [addSubCategoryModal, setSubCategoryModal] = useState(false)
  const [vendors, setVendor] = useState(null)
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('')
  const [tabledata, setTabledata] = useState([]); // Initialize as empty array
  const [relaod, setReload] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [page, setPage] = useState(1);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null); // State for highlighting
  const [readyToQuery, setReadyToQuery] = useState(false); // Delay query execution until state is restored
  const tableRef = useRef(null); // Ref for DataTable scroll position


  // --- EFFECT FOR STATE RESTORATION ---
  useEffect(() => {
    const storedPage = localStorage.getItem(LAST_CATEGORY_LIST_PAGE);
    const storedScrollPos = localStorage.getItem(LAST_CATEGORY_LIST_SCROLL_POS);
    const storedPerPage = localStorage.getItem(LAST_CATEGORY_LIST_PER_PAGE);
    const storedSelectedId = localStorage.getItem(LAST_SELECTED_CATEGORY_ID);
    const storedSearchQuery = localStorage.getItem(LAST_CATEGORY_SEARCH_QUERY);
    const isSearchActive = localStorage.getItem(IS_CATEGORY_SEARCH_ACTIVE) === 'true';
    const backNavigated = localStorage.getItem(IS_BACK_FROM_SUB_CATEGORY) === 'true';

    // Check if we navigated back from a sub-category page
    const navigatedFromSubCategory =
      history.action === 'POP' &&
      history.location &&
      history.location.state &&
      history.location.state.fromSubCategory;

    if (backNavigated && storedPage) {
      const parsedPage = parseInt(storedPage, 10);
      setPage(parsedPage);
      setCurrentPage(parsedPage);

      if (storedPerPage) {
        setPerPage(parseInt(storedPerPage, 10));
      }

      if (storedScrollPos && tableRef.current) {
        setTimeout(() => {
          tableRef.current.parentElement.parentElement.scrollTo(0, parseInt(storedScrollPos, 10));
        }, 100);
      }

      if (storedSelectedId) {
        setSelectedCategoryId(storedSelectedId);
      }

      if (isSearchActive && storedSearchQuery) {
        setSearchQuery(storedSearchQuery);
        // Trigger search refetch after state is set, might need a slight delay
        setTimeout(() => {
          refetchSearch({
            variables: {
              text: storedSearchQuery,
              limit: parseInt(storedPerPage, 10),
              skip: (parsedPage - 1) * parseInt(storedPerPage, 10),
            },
          });
        }, 100);
      }

      // Clean up localStorage items after restoration
      localStorage.removeItem(IS_BACK_FROM_SUB_CATEGORY);
      localStorage.removeItem(LAST_CATEGORY_LIST_PAGE);
      localStorage.removeItem(LAST_CATEGORY_LIST_SCROLL_POS);
      localStorage.removeItem(LAST_CATEGORY_LIST_PER_PAGE);
      localStorage.removeItem(LAST_SELECTED_CATEGORY_ID);
      localStorage.removeItem(LAST_CATEGORY_SEARCH_QUERY);
      localStorage.removeItem(IS_CATEGORY_SEARCH_ACTIVE);

    } else if (!navigatedFromSubCategory) {
      // Fresh load or navigation from somewhere else, clear any lingering state
      setPage(1);
      setCurrentPage(1);
      setSearchQuery('');
      setSelectedCategoryId(null);

      localStorage.removeItem(LAST_CATEGORY_LIST_PAGE);
      localStorage.removeItem(LAST_CATEGORY_LIST_SCROLL_POS);
      localStorage.removeItem(IS_BACK_FROM_SUB_CATEGORY);
      localStorage.removeItem(LAST_CATEGORY_LIST_PER_PAGE);
      localStorage.removeItem(LAST_SELECTED_CATEGORY_ID);
      localStorage.removeItem(LAST_CATEGORY_SEARCH_QUERY);
      localStorage.removeItem(IS_CATEGORY_SEARCH_ACTIVE);
    }

    setReadyToQuery(true); // Allow queries to run after potential state restoration
  }, [history.action, history.location.state]); // Depend on history action/state to detect navigation


  // --- GraphQL Queries ---
  const variables = {
    skip: (page - 1) * perPage,
    limit: perPage
  };

  const variablesSearch = {
    text: searchQuery,
    limit: perPage,
    skip: (page - 1) * perPage,
  };

  const { data: dataSearch, refetch: refetchSearch } = useQuery(
    GET_SEARCH_CATEGORIES, {
    variables: variablesSearch,
    skip: !readyToQuery, // Skip until readyToQuery is true
    onCompleted: (data) => {
      if (searchQuery) { // Only update if a search query is active
        setTabledata(data && data.searchCategories.categories ? data.searchCategories.categories : [])
        setTotalRows(data.searchCategories.totalCount);
      }
    },
    onError: error => {
      const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
      if (isForbiddenError) {
        localStorage.removeItem('user-native');
        localStorage.removeItem('restaurant_id');
        client.clearStore();
        props.history.push('/auth/login');
      }
    },
  });

  const { loading: loadingQuery, error: errorQuery, data, refetch } = useQuery(
    GET_ALL_CATEGORIES, {
    variables,
    skip: !readyToQuery, // Skip until readyToQuery is true
    onCompleted: (data) => {
      if (!searchQuery) { // Only update if no search query is active
        setTabledata(data && data.getCategories ? data.getCategories.categories : []);
        setTotalRows(data && data.getCategories ? data.getCategories.totalCount : 0);
      }
    },
    onError: error => {
      const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
      if (isForbiddenError) {
        localStorage.removeItem('user-native');
        localStorage.removeItem('restaurant_id');
        client.clearStore();
        props.history.push('/auth/login');
      }
    },
  });

  const [mutate] = useMutation(DELETE_CATEGORY, {
    refetchQueries: [{ query: GET_ALL_CATEGORIES }], // Re-fetch all categories after deletion
    onCompleted: () => {
      setSnackbarOpen(true); // Show success message on deletion
      refetch(); // Ensure data is reloaded after delete
    },
    onError: error => {
      const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
      if (isForbiddenError) {
        localStorage.removeItem('user-native');
        localStorage.removeItem('restaurant_id');
        client.clearStore();
        props.history.push('/auth/login');
      }
    },
  });

const toggleModal = vendor => {
  setEditModal(!editModal)
  setVendor(vendor)
}
  // --- General Helper Functions ---
  const closeEditModal = () => {
    setEditModal(false);
  };

  const openaAddVendorModal = () => {
    setAddVendorModal(true);
  };

  const openaAddSubCategoryModal = () => {
    setSubCategoryModal(true);
  };

  const closeAddVendorModal = () => {
    setAddVendorModal(false);
  };

  const closeAddSubCategoryModal = () => {
    setSubCategoryModal(false);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const customSort = (rows, field, direction) => {
    const handleField = row => {
      if (row[field]) {
        return row[field].toLowerCase()
      }
      return row[field]
    }
    return orderBy(rows, handleField, direction)
  }


  // --- Pagination and Search Handlers ---
  const handlePageChange = (newPage) => {
    setPage(newPage);
    setCurrentPage(newPage);
    if (searchQuery) {
      refetchSearch({
        variables: {
          text: searchQuery,
          limit: perPage,
          skip: (newPage - 1) * perPage,
        },
      });
    } else {
      refetch({
        variables: {
          limit: perPage,
          skip: (newPage - 1) * perPage,
        },
      });
    }
  };

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    setPage(1); // Reset to first page when perPage changes
    setCurrentPage(1);
    if (searchQuery) {
      refetchSearch({
        variables: {
          text: searchQuery,
          limit: newPerPage,
          skip: 0,
        },
      });
    } else {
      refetch({
        variables: {
          limit: newPerPage,
          skip: 0,
        },
      });
    }
  };

  const onChangeSearch = e => {
    setSearchQuery(e.target.value);
    setPage(1); // Reset page to 1 on new search
    setCurrentPage(1);
  };

  const handleSearch = () => {
    // This function will be called when the user explicitly triggers search (e.g., presses Enter or clicks search icon)
    refetchSearch();
  }

  const onClickRefetch = () => {
    setSearchQuery(''); // Clear search query
    setPage(1); // Reset page
    setCurrentPage(1);
    refetch(); // Refetch all categories
  }

  // --- Effects for Data Fetching based on State Changes ---
  useEffect(() => {
    if (!readyToQuery) return; // Wait until state restoration is complete

    if (searchQuery) {
      refetchSearch({
        variables: {
          text: searchQuery,
          limit: perPage,
          skip: (page - 1) * perPage,
        },
      });
    } else {
      refetch({
        variables: {
          limit: perPage,
          skip: (page - 1) * perPage,
        },
      });
    }
  }, [page, perPage, searchQuery, readyToQuery, refetch, refetchSearch]);


  // --- DataTable Columns ---
  const columns = [
    {
      name: "Sl No.",
      cell: (row, index) => <>{(page - 1) * perPage + index + 1}</>, // Corrected for pagination
      style: { cursor: 'pointer', minWidth: "200px" },
    },
    {
      name: "Category ID",
      sortable: true,
      selector: '_id',
      cell: (row) => <>{row._id.slice(-5)}</>, // Display last 5 chars of ID
      style: { cursor: 'pointer', minWidth: "200px" },
    },
    {
      name: "Category Name",
      sortable: true,
      selector: 'name',
      style: { cursor: 'pointer', minWidth: "200px" },
    },
    {
      name: "Description",
      sortable: true,
      selector: 'description',
      style: { cursor: 'pointer', minWidth: "150px" },
    },
    {
      name: "Sort Order",
      sortable: true,
      selector: 'sortOrder',
      style: { cursor: 'pointer', minWidth: "100px" },
      cell: (row) => <>{row.sortOrder}</>,
    },
    {
      name: t('Image'),
      cell: row => (
        <>
          {!!row.images && (
            <img
              className="img-responsive"
              src={row.images[0]}
              alt={t('ImageMenu')}
              style={{ width: 30, height: 30, cursor: 'pointer' }}
              onClick={() => {
                // Save current state before navigating to sub-category
                localStorage.setItem(LAST_CATEGORY_LIST_PAGE, page.toString());
                localStorage.setItem(LAST_CATEGORY_LIST_PER_PAGE, perPage.toString());
                localStorage.setItem(LAST_SELECTED_CATEGORY_ID, row._id);
                localStorage.setItem(IS_BACK_FROM_SUB_CATEGORY, 'true');

                if (tableRef.current) {
                  localStorage.setItem(
                    LAST_CATEGORY_LIST_SCROLL_POS,
                    tableRef.current.parentElement.parentElement.scrollTop.toString()
                  );
                }
                if (searchQuery) {
                  localStorage.setItem(IS_CATEGORY_SEARCH_ACTIVE, 'true');
                  localStorage.setItem(LAST_CATEGORY_SEARCH_QUERY, searchQuery);
                } else {
                  localStorage.removeItem(IS_CATEGORY_SEARCH_ACTIVE);
                  localStorage.removeItem(LAST_CATEGORY_SEARCH_QUERY);
                }

                localStorage.setItem('catagery_id', row._id)
                props.history.push({
                  pathname: '/super_admin/mangesubcategory',
                  state: { id: row._id, fromSubCategory: true } // Add flag for navigation
                })
              }}
            />
          )}
          {!row.images && 'No Image'}
        </>
      ),
      selector: 'images',
      style: { cursor: 'pointer', minWidth: "150px" },
    },
    {
      name: t('Action'),
      cell: row => <>{actionButtons(row)}</>
    }
  ]

  const actionButtons = row => {
    const [anchorEl, setAnchorEl] = React.useState(null)
    const open = Boolean(anchorEl)
    const handleClick = event => {
      setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
      setAnchorEl(null)
    }
    return (
      <>
        <Button
          size="20px"
          variant="contained"
          sx={{
            fontWeight: 'bold',
            backgroundColor: theme.palette.warning.dark,
            color: theme.palette.common.white,
            padding: 0,
            height: '15px',
            fontSize: '7px',
            '&:hover': {
              border: '2px solid #637BFE',
              color: theme.palette.warning.dark,
              backgroundColor: "white"
            }
          }}
          onClick={e => {
            e.preventDefault()
            // Save current state before navigating to sub-category
            localStorage.setItem(LAST_CATEGORY_LIST_PAGE, page.toString());
            localStorage.setItem(LAST_CATEGORY_LIST_PER_PAGE, perPage.toString());
            localStorage.setItem(LAST_SELECTED_CATEGORY_ID, row._id);
            localStorage.setItem(IS_BACK_FROM_SUB_CATEGORY, 'true');

            if (tableRef.current) {
              localStorage.setItem(
                LAST_CATEGORY_LIST_SCROLL_POS,
                tableRef.current.parentElement.parentElement.scrollTop.toString()
              );
            }
            if (searchQuery) {
              localStorage.setItem(IS_CATEGORY_SEARCH_ACTIVE, 'true');
              localStorage.setItem(LAST_CATEGORY_SEARCH_QUERY, searchQuery);
            } else {
              localStorage.removeItem(IS_CATEGORY_SEARCH_ACTIVE);
              localStorage.removeItem(LAST_CATEGORY_SEARCH_QUERY);
            }

            localStorage.setItem('catagery_id', row._id)
            localStorage.setItem('CategoryName', row.name)
            props.history.push({
              pathname: '/super_admin/mangesubcategory',
              state: { id: row._id, CategoryName: row.name, fromSubCategory: true } // Add flag for navigation
            })
          }}>
          {t('View Sub Category')}
        </Button>
        <div>
          <IconButton
            aria-label="more"
            id="long-button"
            aria-haspopup="true"
            onClick={handleClick}>
            <MoreVertIcon fontSize="small" />
          </IconButton>
          <Paper>
            <Menu
              id="long-menu"
              MenuListProps={{
                'aria-labelledby': 'long-button'
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}>
              <MenuItem
                onClick={e => {
                  e.preventDefault()
                  toggleModal(row);
                }}
                style={{ height: 25 }}>
                <ListItemIcon>
                  <EditIcon fontSize="small" style={{ color: 'green' }} />
                </ListItemIcon>
                <Typography color="green">{t('Edit')}</Typography>
              </MenuItem>
              <MenuItem
                disabled
                onClick={e => {
                  e.preventDefault()
                  setIsOpen(true)
                  setTimeout(() => {
                    setIsOpen(false)
                  }, 5000)
                  // uncomment this for paud version
                  // mutate({ variables: { id: row._id } });
                }}
                style={{ height: 25 }}>
                <ListItemIcon>
                  <DeleteIcon fontSize="small" style={{ color: 'red' }} />
                </ListItemIcon>
                <Typography color="red">{t('Delete')}</Typography>
              </MenuItem>
            </Menu>
          </Paper>
        </div>
      </>
    )
  }

  // --- Conditional Row Styles for Highlighting ---
  const conditionalRowStyles = [
    {
      when: row => row._id === selectedCategoryId,
      style: {
        backgroundColor: theme.palette.action.selected, // Highlight row
      },
    },
  ];

  // --- Render Logic ---
  if (!readyToQuery || loadingQuery) return <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}>
    <CustomLoader />
  </div>; // Show loading spinner or wait for readyToQuery

  if (errorQuery) {
    return <span>{`Error! ${errorQuery.message}`}</span>; // Show error message
  }

  // Check if data exists and has the expected structure
  if (!data && !dataSearch) {
    return <span>No data available or unexpected data structure.</span>;
  }

  return (
    <>
      <Header />
      <Container className={golbalClasses.flex}>
        <Box sx={{ textAlign: 'right', mb: 3 }}>
          <Button
            className={golbalClasses.dashbordBtn}
            onClick={openaAddVendorModal}
          >
            <Icon icon="ic:twotone-plus" style={{ color: "white" }} />  {t('AddNewCategory')}
          </Button>
          <Button
            className={golbalClasses.dashbordBtn}
            onClick={openaAddSubCategoryModal}
          >
            <Icon icon="ic:twotone-plus" style={{ color: "white" }} />  {t('Add New Sub Category')}
          </Button>
        </Box>

        {addVendorModal && (
          <Grid container>
            <Grid item xs={12} order={{ xs: 2, lg: 1 }}>
              <Grid
                sx={{ display: { xs: 'none', lg: 'block' } }}
                item
                mt={5}
                ml={-2}
                order={{ xs: 1, lg: 2 }}
              >
                <Modal
                  open={addVendorModal}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onClose={closeAddVendorModal}
                >
                  <AddCategory onClose={closeAddVendorModal} refetch={refetch} />
                </Modal>
              </Grid>
            </Grid>
          </Grid>
        )}

        {addSubCategoryModal && (
          <Grid container>
            <Grid item xs={12} order={{ xs: 2, lg: 1 }}>
              <Grid
                sx={{ display: { xs: 'none', lg: 'block' } }}
                item
                mt={5}
                ml={-2}
                order={{ xs: 1, lg: 2 }}
              >
                <Modal
                  open={addSubCategoryModal}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onClose={closeAddSubCategoryModal}
                >
                  <AddSubCategory onClose={closeAddSubCategoryModal} refetch={refetch} />
                </Modal>
              </Grid>
            </Grid>
          </Grid>
        )}

        {errorQuery && <span> `Error! ${errorQuery.message}`</span>}
        <DataTable
          ref={tableRef} // Attach ref to DataTable
          subHeader={true}
          subHeaderComponent={
            <>
              <SearchBar
                value={searchQuery}
                onChange={onChangeSearch}
                onSearch={handleSearch} // Explicit search trigger
                onClear={onClickRefetch} // Clear search and refetch all
                onClick={() => onClickRefetch()} // Also clear on search button click if search bar is empty
              />
            </>
          }
          title={<TableHeader title={t('Manage Category')} />}
          columns={columns}
          data={tabledata || []}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          paginationPerPage={perPage}
          paginationDefaultPage={currentPage}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          progressPending={loadingQuery} // Use loadingQuery for DataTable's progress
          progressComponent={<CustomLoader />}
          sortFunction={customSort}
          customStyles={customStyles}
          conditionalRowStyles={conditionalRowStyles} // Apply highlighting
          onRowClicked={row => {
            setSelectedCategoryId(row._id); // Update selected ID on row click
          }}
        />
        <Modal
          open={editModal}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onClose={() => {
            toggleModal()
          }}>
          <AddCategory vendor={vendors} onClose={closeEditModal} refetch={refetch} />
        </Modal>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={handleSnackbarClose} severity="success">
            Deleted Successfully!
          </Alert>
        </Snackbar>
      </Container>
    </>
  )
}

export default withTranslation()(ManageCategory)
